import { render, staticRenderFns } from "./facebookRating.vue?vue&type=template&id=7c9a4b42"
import script from "./facebookRating.vue?vue&type=script&lang=js"
export * from "./facebookRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c9a4b42')) {
      api.createRecord('7c9a4b42', component.options)
    } else {
      api.reload('7c9a4b42', component.options)
    }
    module.hot.accept("./facebookRating.vue?vue&type=template&id=7c9a4b42", function () {
      api.rerender('7c9a4b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/facebookRating.vue"
export default component.exports